enum MeterSubmissionStatus {
  EXTRACTED = "EXTRACTED",
  EMAILED = "EMAILED",
  SUBMITTED = "SUBMITTED",
  FAILED = "FAILED",
}

enum MeterConfidence {
  HIGH = "high",
  MEDIUM = "medium",
  LOW = "low",
}

enum MeterConfirmAction {
  EMAIL = "email_sent",
  FORM = "form_submitted",
}

enum MeterSubmissionKind {
  EMAIL = "email",
  FORM = "form",
}

interface MeterProviderInfo {
  id: number;
  name: string;
  addressName: string | null;
  supportsSecondaryReading: boolean;
  submission: MeterSubmissionKind;
}

interface MeterExtractionResponse {
  id: number;
  readingValue: string;
  secondaryReadingValue: string | null;
  meterNumber: string | null;
  rawText: string | null;
  confidence: MeterConfidence | null;
  notes: string | null;
  photoTakenAt: string | null;
}

interface MeterReadingEntry {
  id: number;
  providerId: number;
  providerName: string;
  addressProviderId: number | null;
  addressName: string | null;
  readingValue: string;
  secondaryReadingValue: string | null;
  status: MeterSubmissionStatus;
  submittedAt: string | null;
  errorMessage: string | null;
  createdAt: string;
}

interface MeterSettingsLinkedAddress {
  id: number;
  name: string;
}

interface MeterSettingsResponse {
  provider: MeterProviderInfo;
  addressProviderId: number | null;
  reportName: string | null;
  reportAddress: string | null;
  reportCustomerCode: string | null;
  reportPhone: string | null;
  reportEmail: string | null;
  reportCc: string | null;
  address: MeterSettingsLinkedAddress | null;
}

interface MeterSettingsUpdate {
  reportName?: string | null;
  reportAddress?: string | null;
  reportCustomerCode?: string | null;
  reportPhone?: string | null;
  reportEmail?: string | null;
  reportCc?: string | null;
}

interface MeterPhotoExif {
  dateTimeOriginal?: string;
  offsetTimeOriginal?: string;
}

interface MeterExtractRequest {
  providerId: number;
  photo: string;
  mimeType?: string;
  exif?: MeterPhotoExif | null;
}

interface MeterConfirmRequest {
  providerId: number;
  id: number;
  readingValue: string;
  secondaryReadingValue?: string | null;
}

interface MeterConfirmResponse {
  success: boolean;
  action: MeterConfirmAction;
}

interface MeterProviderTabItem {
  provider: MeterProviderInfo;
  addressName: string | null;
}

type RequiredMeterSettingsField = "reportName" | "reportAddress" | "reportCustomerCode" | "reportPhone" | "reportEmail";

export {
  MeterSubmissionStatus,
  MeterConfidence,
  MeterConfirmAction,
  MeterSubmissionKind,
  type MeterProviderInfo,
  type MeterProviderTabItem,
  type MeterExtractionResponse,
  type MeterReadingEntry,
  type MeterSettingsLinkedAddress,
  type MeterSettingsResponse,
  type MeterSettingsUpdate,
  type MeterExtractRequest,
  type MeterConfirmRequest,
  type MeterConfirmResponse,
  type MeterPhotoExif,
  type RequiredMeterSettingsField,
};
